var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gutenberg-home"}},[_c('GutenbergHomeDisclaimer'),_c('HomeNewProducts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }